import { getUnlinkedCreditInvoices, LinkCreditInvoice, UnLinkCreditInvoice } from "../../../../services/requests/billing/liquid-billing-requests";
import { FormItemType } from "../../../UI/view/component-map";
import { DataSource } from "../../../UI/view/data-source";
import { ListView, ListViewColumnType, initListView } from "../../../UI/view/list-view";

export const unlinkedCreditInvoicesDataSource = {
  request: getUnlinkedCreditInvoices,
  name: 'unlinkedCreditInvoices',
  pk: 'billingId',
} as DataSource;

export const unlinkedCreditInvoices = {
  columns: [
    {
      accessor: 'billingId',
      Header: 'Billing Id',
      defaultSort: true
    },
    {
      accessor: 'jdeVolume',
      Header: 'JDE Volume',
    },
    {
      accessor: 'dateInvoiced',
      Header: 'Date Invoiced',
      type: ListViewColumnType.date
    },
    {
      accessor: 'customerName',
      /*       defaultSort: true, */
      Header: 'Customer Name',
      type: ListViewColumnType.linkEdit,
      serverExpression: 'LiquidCustomer.customerName',
      linkPath: ({ row }) => `/billing/liquidedit/${row.original.billingId}`
    },
  ]
} as ListView;

export const UnlinkedCreditInvoices = initListView(unlinkedCreditInvoices, unlinkedCreditInvoicesDataSource)

export const unlinkedCreditInvoicesField = {
  singleSelect: true,
  noGlobalFilterPadding: true,
  columns: [
    {
      type: ListViewColumnType.radio,
      accessor: 'checked',
      excludeGlobalFilter: true,
    },
    {
      accessor: 'billingId',
      Header: 'Billing Id',
      defaultSort: true
    },
    {
      accessor: 'jdeVolume',
      Header: 'JDE Volume',
    },
    {
      accessor: 'dateInvoiced',
      Header: 'Date Invoiced',
      type: ListViewColumnType.date
    },
    {
      accessor: 'customerName',
      /*       defaultSort: true, */
      Header: 'Customer Name',
      type: ListViewColumnType.linkEdit,
      serverExpression: 'LiquidCustomer.customerName',
      linkPath: ({ row }) => `/billing/liquidedit/${row.original.billingId}`
    },
  ]
} as ListView;

export const UnlinkedCreditInvoicesField = initListView(unlinkedCreditInvoicesField, unlinkedCreditInvoicesDataSource)


export const UnlinkedCreditInvoicesFieldLinker = initListView({
  ...unlinkedCreditInvoicesField,
  toolbar: [
    {
      type: FormItemType.button,
      label: 'Link',
      variant: 'primary',
      style: { marginLeft: 2 },
      disabled: ({watch}) => watch('linkedCreditInvoiceId'),
      handler: async ({ methods, confirm }) => {
        const { getValues } = methods;
        const { billingId, creditInvoiceIdToLink } = getValues();

        if (creditInvoiceIdToLink?.length !== 1) {
          await confirm('Please select a single credit invoice to link.', true);
          return;
        }
        let isError = false;
        let result = null;
        try {
          result = await LinkCreditInvoice({ billingId, creditInvoiceIdToLink: creditInvoiceIdToLink[0]?.billingId });
        } catch {
          isError = true;
        }
        if (isError) {
          await confirm('There was an error linking the credit invoice.', true);
        } else {
          //redirect to created invoice. We need the invoice id!\
          await confirm('Credit Invoice Linked.', true);
          methods.loadEntity();
        }
      }
    },
    {
      type: FormItemType.button,
      label: 'UnLink',
      variant: 'primary',
      style: { marginLeft: 2 },

      handler: async ({ methods, confirm }) => {
        const { getValues } = methods;
        const { billingId, linkedCreditInvoiceId } = getValues();
        let isError = false;
        let result = null;
        if (linkedCreditInvoiceId == null) {
          await confirm('This invoice is not linked.', true);
          return;
        }
        try {
          result = await UnLinkCreditInvoice({ billingId, creditInvoiceIdToLink: linkedCreditInvoiceId });
        } catch {
          isError = true;
        }
        if (isError) {
          await confirm('There was an error unlinking the credit invoice.', true);
        } else {
          //redirect to created invoice. We need the invoice id!\
          await confirm('Credit Invoice Unlinked.', true);
          methods.loadEntity();
        }
      }
    }
  ]
}, unlinkedCreditInvoicesDataSource, (state) => {
  return state.unlinkedCreditInvoices?.data?.filter(item => item.customerId === state.liquidbilling?.current?.data?.customerId) ?? [];
})